import { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Gift } from "lucide-react";

const COLORS = ["#7944E4", "#F5B700", "#FF6B8B", "#2EC4B6", "#ffffff"];

export function Confetti() {
  const reduce = useReducedMotion();
  const bits = useMemo(() => Array.from({ length: 36 }, (_, i) => ({
    id: i, x: (Math.random() - 0.5) * 360, y: -(120 + Math.random() * 180), r: Math.random() * 540 - 270,
    c: COLORS[i % COLORS.length], d: Math.random() * 0.15, w: 6 + Math.random() * 5,
  })), []);
  if (reduce) return null;
  return (
    <div className="pointer-events-none absolute inset-x-0 top-56 flex justify-center z-30" aria-hidden="true" data-testid="gift-confetti">
      {bits.map((b) => (
        <motion.span key={b.id} className="absolute rounded-[2px]" style={{ background: b.c, width: b.w, height: b.w * 0.45 }}
          initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
          animate={{ x: b.x, y: [0, b.y, b.y + 260], opacity: [1, 1, 0], rotate: b.r }}
          transition={{ duration: 1.5, delay: b.d, ease: "easeOut" }} />
      ))}
    </div>
  );
}

export function GiftEnvelope({ name, onOpen }) {
  return (
    <motion.button type="button" onClick={onOpen} data-testid="gift-envelope"
      aria-label="Abrir regalo"
      initial={{ opacity: 0, y: 24, rotate: -2 }} animate={{ opacity: 1, y: 0, rotate: 0 }}
      exit={{ opacity: 0, scale: 0.9, rotateX: 70, transition: { duration: 0.45 } }}
      whileHover={{ y: -4, rotate: -1 }} whileTap={{ scale: 0.97 }}
      className="relative w-full aspect-[4/3] rounded-3xl bg-primary text-primary-foreground overflow-hidden shadow-[0_24px_60px_-20px_rgba(121,68,228,0.7)] grain-overlay">
      <span className="absolute inset-x-0 top-0 h-1/2 bg-[linear-gradient(to_bottom_right,transparent_49.5%,rgba(255,255,255,0.12)_50%),linear-gradient(to_bottom_left,transparent_49.5%,rgba(255,255,255,0.12)_50%)] bg-[length:50%_100%] bg-no-repeat [background-position:left,right]" />
      <span className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-6 bg-sun/90" />
      <span className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-6 bg-sun/90" />
      <span className="absolute inset-0 grid place-items-center">
        <motion.span animate={{ scale: [1, 1.08, 1] }} transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
          className="w-20 h-20 rounded-full bg-white text-primary grid place-items-center shadow-lg ring-4 ring-sun">
          <Gift className="w-9 h-9" />
        </motion.span>
      </span>
      <span className="absolute inset-x-0 bottom-0 p-4 text-center bg-gradient-to-t from-black/30 to-transparent">
        <span className="block text-lg font-extrabold" data-testid="gift-envelope-title">{name}, tienes un regalo</span>
        <span className="block text-sm opacity-90">Toca para abrir</span>
      </span>
    </motion.button>
  );
}
